import React from 'react';
import { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Button, Modal } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { ButtonType } from 'antd/lib/button';

const { Item } = Menu;

interface HandleConfirm {
  (action: string): void;
}

export interface ActionOption {
  action: string;
  label: React.ReactNode;
  disabled?: boolean;
  askConfirmation?: boolean;
  style?: React.CSSProperties;
}

interface ActionButtonProps {
  createButtonType?: ButtonType;
  createButtonLabel?: string;
  actionType?: 'inbound' | 'outbound';
  actionOptions: ActionOption[];
  handleClick: HandleConfirm;
  selectedItems: number[];
  disabled?: boolean;
  loading?: boolean;
}

function showConfirm(
  handleOk: HandleConfirm,
  action: string,
  texts: {
    confirm: string;
    ok: string;
    cancel: string;
  }
): void {
  Modal.confirm({
    title: texts.confirm,
    okText: texts.ok,
    cancelText: texts.cancel,
    autoFocusButton: null,
    onOk() {
      handleOk(action);
    },
  });
}

const ActionsButton: React.FC<ActionButtonProps> = ({
  createButtonType = 'default',
  createButtonLabel,
  actionType = 'inbound',
  selectedItems = [],
  actionOptions: options = [],
  handleClick,
  disabled,
  loading,
}) => {
  const hasItemsSelected = selectedItems.length > 0;
  const { formatMessage } = useIntl();
  const modalTetxs = {
    confirm: formatMessage(
      {
        defaultMessage:
          'Do you really want to delete {number, plural, one{# item} other{# items}}?',
      },
      { number: selectedItems.length }
    ),
    ok: formatMessage({ defaultMessage: 'Yes' }),
    cancel: formatMessage({ defaultMessage: 'Cancel' }),
  };
  const menu = (
    <Menu
      onClick={(e): void => {
        const action = options.find((o) => o.action === e.key);
        if (actionType === 'inbound') {
          if (hasItemsSelected) {
            if (action && action.askConfirmation) {
              showConfirm(handleClick, e.key as string, modalTetxs);
            } else {
              handleClick(e.key as string);
            }
          }
        } else {
          handleClick(e.key as string);
        }
      }}
    >
      {options.map(({ action, ...item }) => (
        <Item
          key={action}
          data-testid={action}
          disabled={item.disabled}
          style={item.askConfirmation ? item.style : {}}
        >
          {item.label}
        </Item>
      ))}
    </Menu>
  );
  return (
    <Dropdown disabled={loading || disabled} overlay={menu} trigger={['click']}>
      <Button type={createButtonType}>
        {createButtonLabel || <FormattedMessage defaultMessage="Actions" />}

        {loading ? (
          <LoadingOutlined css="padding-left: 10px" />
        ) : (
          <DownOutlined css="padding-left: 10px" />
        )}
      </Button>
    </Dropdown>
  );
};

export default ActionsButton;
